module.exports = __webpack_public_path__ + "media/customizations/default/spinner-tertiary-6d36d3cde4bd31daaccabdb5874e9201.gif";